import { render } from "./CytopathologyReport.vue?vue&type=template&id=b29368ba"
import script from "./CytopathologyReport.vue?vue&type=script&lang=js"
export * from "./CytopathologyReport.vue?vue&type=script&lang=js"

import "./CytopathologyReport.vue?vue&type=style&index=0&id=b29368ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__